var localurl = window.location.href
var ajax_url = null

// 开发环境下的地址  地址要拼写全不要拼写重复了
const BASE_URL_DEV = 'http://8.140.196.222:8031/VMSAPI'
const BASE_URL_PRD = 'https://www.qzwmsj.com/api/VMSAPI'

if (localurl.indexOf('8.146') > 0 || localurl.indexOf('localhost') > 0) {
	ajax_url = BASE_URL_DEV
	// ajax_url = BASE_URL_PRD
} else {
	ajax_url = BASE_URL_PRD
}

module.exports = {
	ajax_url: ajax_url
}
